import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { PHOTO_UPLOAD, PHOTO_UPLOAD_TYPE_SELECT } from "data/links";

const validReferrerPathnames = [PHOTO_UPLOAD, PHOTO_UPLOAD_TYPE_SELECT];

export const referrerIsValid = location => {
    return validReferrerPathnames.includes(location?.state?.referrer?.pathname);
};

const NoRedirect = () => null;

const RedirectToPhotoUploadView = ({ history }) => {
    useEffect(() => {
        history.replace(PHOTO_UPLOAD);
    }, []);

    return null;
};

const RedirectOnInvalidReferrer = () => {
    const history = useHistory();
    const location = useLocation();

    const [redirect, setRedirect] = useState(<NoRedirect />);

    useEffect(() => {
        if (!referrerIsValid(location)) {
            setRedirect(<RedirectToPhotoUploadView history={history} />);
        }
    }, []);

    return redirect;
};

export default RedirectOnInvalidReferrer;
